import { render, staticRenderFns } from "./GrowingNumber.vue?vue&type=template&id=5905b9b4&"
import script from "./GrowingNumber.vue?vue&type=script&lang=ts&"
export * from "./GrowingNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports